import { Button, Modal } from "antd";
import "./style.scss";
import { useInfoUser } from "../../store/UserStore";
import { PinnedMessage } from "../../pages/conversation/chat/PinnedMessageModal";

const PinnedModal = ({
  title,
  content,
  onCancel,
  open,
  onConfirm,
  pinnedMessages,
}) => {
  const { languageMap } = useInfoUser();

  return (
    <Modal
      width={450}
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      className="custom-confirm-modal"
    >
      <div className="modal-header">
        <div className="modal-title">{title ?? "Xác nhận"}</div>
        <div className="modal-divider" />
      </div>

      <div className="text-base mb-3">{content}</div>

      {pinnedMessages && (
        <div className="mb-3 pointer-events-none cursor-not-allowed bg-[#f6f6f6] rounded-md">
          <PinnedMessage pinData={pinnedMessages?.[2]} isNotice={true} />
        </div>
      )}

      <div className="flex justify-end gap-2">
        <Button
          className="!bg-[#ffffff] !text-black hover:!bg-[#d9d9d9] font-medium"
          onClick={onCancel}
        >
          {languageMap?.["modal.cancel"] ?? "Không"}
        </Button>
        <Button
          className="!bg-[#ff4d4f] !text-white hover:!bg-[#ff7875] font-medium"
          onClick={() => {
            onConfirm?.();
            onCancel?.();
          }}
        >
          {languageMap?.["modal.ok"] ?? "Xóa"}
        </Button>
      </div>
    </Modal>
  );
};

export { PinnedModal };
